import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { CrraAlertsModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-crra-alerts',
  templateUrl: './manage-crra-alerts.component.html',
  styleUrls: ['./manage-crra-alerts.component.css']
})
export class ManageCrraAlertsComponent implements OnInit {

  tokenKey: string = '';
  userId: number = 0;
  SelectedTool: string;
  productId: number = 1;
  multiSelectDropDownHeight: number = 200;


  CrraAlertsModel = new CrraAlertsModel()

  addUpdateCrraAlert = new FormGroup({
    updateId: new FormControl(''),
    updateDate: new FormControl(''),
    updateNote: new FormControl(''),
    isNotify: new FormControl(0),
  });

  isCrraAlerts: boolean = true;
  updateId: number = 0;
  isDataLoad: boolean = false;
  isViewMode: boolean = false;

  isNotify: boolean ;

  pageNumber:number;
  pageSize:number;
  Email:string = '';
  Name:string = '';
  orderBy:string;
  fundName:string;


  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly checkAuth: CheckAuth,
    private readonly crraAlertServices: TrfaAlertService,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum.crra;
    this.titleService.setTitle('Manage CRRA Alert');
  }

  ngOnInit() {
    this.pageNumber = 1;
    this.pageSize = 10;
    this.orderBy = 'updateId ASC'
    this.activedRoute.params.subscribe((params: Params) => {

      if (params['id']) {
        if (params['id'] != null) {
          this.isCrraAlerts = false;
          this.updateId = params['id'];
          this.userId = params['userid'];
          this.GetCrraAlertsByUsers();
        }
      }
      else {
        this.userId = 0;
      }
    });
  }
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  
  GetCrraAlertsByUsers(): void {
    this.isDataLoad = true;
    this.crraAlertServices.GetCrraAlertsByUser(this.tokenKey, this.updateId,this.pageNumber,this.pageSize,this.userId,this.orderBy).subscribe(
      data => {
        if (data["crraAlertuser"] != null && data["status"] != "Failure") {

          this.CrraAlertsModel = data['crraAlertuser'][0];

          this.Email=this.CrraAlertsModel.email;
          this.Name=this.CrraAlertsModel.name;
          this.fundName=this.CrraAlertsModel.fundName;

          if (this.CrraAlertsModel != null) {
            const updateDate = new Date(this.CrraAlertsModel.updateDate);
          
            let dd1 = updateDate.getDate().toString();
            if (parseInt(dd1) < 10) {
              dd1 = '0' + dd1;
            }
          
            let mm1 = (updateDate.getMonth() + 1).toString();
            if (parseInt(mm1) < 10) {
              mm1 = '0' + mm1;
            }
          
            this.CrraAlertsModel.updateDate = `${mm1}/${dd1}/${updateDate.getFullYear()}`;
          }
          
          this.addUpdateCrraAlert.setValue({
            updateId: this.CrraAlertsModel.updateId,
            updateDate: this.CrraAlertsModel.updateDate,
            updateNote: this.CrraAlertsModel.updateNote,
            isNotify: this.CrraAlertsModel.isNotify
          });

          this.isDataLoad = false;
        }
        else {
          this.isDataLoad = false;
          this.showMessage(data["message"], 'Error', 'error');
        }
      }, error => {
        this.isDataLoad = false;
        this.showMessage(error, 'Error', 'error');
      })

  }


  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  isAlertDate(dateArray: any) {
    if (dateArray != null) {
      let dd1 = dateArray.getDate().toString();
      if (parseInt(dd1.toString()) < 10)
        dd1 = '0' + dd1.toString();

      let mm1 = (dateArray.getMonth() + 1).toString();
      if (parseInt(mm1.toString()) < 10)
        mm1 = '0' + mm1.toString();

      this.CrraAlertsModel.updateDate = mm1 + '/' + dd1 + '/' + dateArray.getFullYear();
    }
    else
      this.CrraAlertsModel.updateDate = null;
  }

  saveAddUpdateCrraAlert(addUpdateCrraAlert: any) {
    if (addUpdateCrraAlert.value['updateDate'] == '') {
      this.showMessage('Please select alert date', 'Error', 'error');
      return;
    }
    let currentDate = new Date();
    if (new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) > addUpdateCrraAlert.value["updateDate"]) {
      this.showMessage('Previous alert date not allow', 'Error', 'error');
      return;
    }

    if (addUpdateCrraAlert.value['updateNote'] == '' || typeof (addUpdateCrraAlert.value['updateNote']) == 'undefined') {
      this.showMessage('Please enter updateNote', 'Error', 'error');
      return;
    }
    if (addUpdateCrraAlert.value['updateNote'] != '') {
      if (addUpdateCrraAlert.value['updateNote'].toString().trim() == '') {
        this.showMessage('Please enter updateNote', 'Error', 'error');
        return;
      }
    }

    if (typeof (addUpdateCrraAlert.value['updateId']) == 'undefined') {
      this.CrraAlertsModel.updateId = 0;
    }
    else {
      this.CrraAlertsModel.updateId = addUpdateCrraAlert.value['updateId'];
    }

    if (typeof (addUpdateCrraAlert.value['updateNote']) == 'undefined') {
      this.CrraAlertsModel.updateNote = '';
    }
    else {
      this.CrraAlertsModel.updateNote = addUpdateCrraAlert.value['updateNote'];
    }
    this.CrraAlertsModel.isNotify = this.isNotify;
    this.CrraAlertsModel.userId = this.userId;
    this.CrraAlertsModel.updateDate =addUpdateCrraAlert.value["updateDate"]
    this.CrraAlertsModel.productId=this.productId;
    
    this.crraAlertServices.AddUpdateCrraAlerts(this.tokenKey, this.CrraAlertsModel).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('Crra alerts Updated successfully', 'Success', 'success');
          this.router.navigate(['/admin/crra/crra-Alerts']);
        }
        else
          this.showMessage(data['status'], 'Error', 'error');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }
  
  removeHTMLTags(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();
    return str.replace(/<[^>]*>/g, '');
  }

  setSendEmailNotificationChecked($event) {
    this.isNotify = $event.target.checked;
  }
}